import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_2df2e56285: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_2df2e56285",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Women-Owned Sustainable Beauty and Accessory Staples",
  description:
    "A collection of hair accessories and bath staples from your favorite women-led brands that prioritize eco-friendly materials and sustainable production.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/357f507398f6af6f7582d0b1ac2998b636dab794034a3da635ff4e9353ca2de9.png",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/357f507398f6af6f7582d0b1ac2998b636dab794034a3da635ff4e9353ca2de9.png",
    "https://cdn.faire.com/fastly/bd549b686b4591a51528d834e85ff719a4af011a7bfc97aee8ff12191fc3e24f.jpeg",
    "https://cdn.faire.com/fastly/762546ed1c6d62bfd7e694a36cca8099cdb06ae35e46b9daa0bca4b9d784a09b.jpeg",
    "https://cdn.faire.com/fastly/0906fab7e96152e1eff6065bbf1980d17ae1c62c802a668f313bf39be7f582e9.jpeg",
    "https://cdn.faire.com/fastly/d3deed65d013d14186f1aff91e0743b866dbe527d4d242b2c6844627dd783699.jpeg",
    "https://cdn.faire.com/fastly/06b812a4e6e0da424cab08459720045f8868d699f7d778ef27fec02a214d694a.jpeg",
  ],
  itemCount: 19,
  source: "eric_themes_ideas",
  teaser: "thi_2df2e56285",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
